import React from "react";
import { FaHeart } from "react-icons/fa";
import "../footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p className="made-with">
        Made with <FaHeart className="heart-icon" /> by Shoaib © {new Date().getFullYear()} All rights reserved.
      </p>
     
    </footer>
  );
}

export default Footer;
